import { Row, Col } from 'src/componentes/grid';
import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { capitalizeFirstLetter } from 'src/utils/string';
import Input from 'src/componentes/input';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import RiscoLookup from 'src/lookups/item';
import StatusPlanoContingenciaLookup from 'src/lookups/StatusPlanoContingenciaLookup';

const BasicsSection = ({ model, resources, intl, searchQuery }) => {
  const fields = [
    { label: intl.formatMessage({ id: 'idIntegracao' }), id: 'idIntegracao' },
    { label: intl.formatMessage({ id: 'nome' }), id: 'nome' },
    { label: intl.formatMessage({ id: 'status' }), id: 'status' },
    { label: resources?.responsavel, id: 'responsavel' },
    { label: resources.risco, id: 'riscoAtrelado' },
  ].filter(Boolean);

  const matchCount = fields.filter((f) =>
    matchesSearch(f.label, searchQuery)
  ).length;

  const visibleFields = fields.filter((f) =>
    matchesSearch(f.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  const isVisible = (id) => visibleFields.some((f) => f.id === id);

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'label.informacoesBasicas' })}
      startOpen={true}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {isVisible('idIntegracao') && (
          <Col md={12}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
        )}

        {isVisible('nome') && (
          <Col md={12}>
            <Input model={model.getModel('nome')} />
          </Col>
        )}

        {isVisible('status') && (
          <Col md={12}>
            <StatusPlanoContingenciaLookup model={model.getModel('status')} />
          </Col>
        )}

        {isVisible('responsavel') && (
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              abrirEmDrawer
              exibirGrupos={false}
              labelComoTitulo
              multi={false}
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'responsavel' },
                    { responsavel: resources.responsavel }
                  )
                ),
                value: model.getModel('responsavel').value,
                requestChange: model.getModel('responsavel').requestChange,
                errors: model.getModel('responsavel').errors,
              }}
            />
          </Col>
        )}

        {isVisible('riscoAtrelado') && (
          <Col md={12}>
            <RiscoLookup
              clearable
              data={{ tipoId: 6 }}
              model={{
                label: capitalizeFirstLetter(resources.risco),
                value: model.getModel('riscoAtrelado').value,
                requestChange: model.getModel('riscoAtrelado').requestChange,
              }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default BasicsSection;
